import { initGraphQLTada } from 'gql.tada'
import type { introspection } from '@/graphql-env'
import type { Module } from '@/modules/companies'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    Date: string
    DateTime: string
    TimeDelta: string
    Time: string
    Decimal: number

    // Enums
    ModuleNames: Module
  }
}>()
